/**
 * Is dit ons eigen adres of nummer, en dus nooit dat van een klant?
 *
 * Aanleiding (Huygen, 03-11-2026): de doorverwijs-dialoog viste e-mail en
 * telefoon uit de laatste klantmail, inclusief het citaat van onze eigen
 * reply daaronder. Zo werd info@kleda.nl het klantadres en ons 088-nummer
 * het klantnummer: de doorverwijsmail ging aan onszelf en de partner-lead
 * kreeg geen bruikbare klant. De klasse: alles wat uit een mailbody wordt
 * gevist kan onze eigen handtekening zijn. Een eigen adres of nummer is per
 * definitie geen klantgegeven, op welk pad het ook binnenkomt.
 *
 * Gedeeld door UI (DoorverwijsDialog), extractie (doorverwijs-prefill) en de
 * schrijfpaden (inbox/doorverwijzen, inbox/reply): gate en uitvoerder
 * hanteren dezelfde regel.
 */
export const EIGEN_DOMEINEN = [
  'kleda.nl',
  'cincocleaning.com',
  'sofasaver.nl',
  'schoonhuisshop.nl',
  'vloerkleedreinigen.com',
  'bankreinigen.nl',
] as const;

/** Kantoornummers: Kleda 088-2999277, Cinco 088-2999299 en de rest van de 088-2999-reeks. */
const EIGEN_NUMMER_PREFIX = '31882999';

export function isEigenEmail(email: string | null | undefined): boolean {
  const adres = (email || '').trim().toLowerCase();
  const at = adres.lastIndexOf('@');
  if (at === -1) return false;
  const domein = adres.slice(at + 1).replace(/>$/, '');
  return EIGEN_DOMEINEN.some((d) => domein === d || domein.endsWith(`.${d}`));
}

export function isEigenTelefoon(telefoon: string | null | undefined): boolean {
  let cijfers = (telefoon || '').replace(/\D/g, '');
  if (cijfers.startsWith('0031')) cijfers = cijfers.slice(2);
  else if (cijfers.startsWith('0')) cijfers = `31${cijfers.slice(1)}`;
  return cijfers.startsWith(EIGEN_NUMMER_PREFIX);
}
